function Switch({ toggle, setToggle }) {
  const toggleClass = " transform translate-x-3";
  return (
    //   Switch Container
    <div
      onClick={() => {
        setToggle(!toggle);
      }}
      className="md:w-10 md:h-6 w-9 h-6 p-1 flex items-center bg-gray-300 dark:bg-indigo-500 rounded-full  cursor-pointer"
    >
      {/* Switch */}
      <div
        className={
          "bg-white dark:bg-primary-dark md:w-5 md:h-5 h-4 w-5 rounded-full shadow-md transform" +
          (toggle ? null : toggleClass)
        }
      ></div>
    </div>
  );
}

export default Switch;
